import React, { useEffect, useMemo, useState } from "react";
import { STRIPE_DASHBOARD_TABS } from "Constants/constant";
import StripeTabItem from "./StripeTabItem";
import PaymentMethod from "../Payment";
import StripeInvoices from "../Invoices/Invoices";
import "./StripeTabs.css";
import SubscriptionDetails from "../Subscription/SubscriptionDetails";
import { stripeDefaultPaymentMethod } from "store/actions/sp.actions";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentSettings } from "store/selector/auth.selector";
import usePayrollAuthentication from "hooks/usePayrollAuthentication";
import { trackTabSwitch } from "Utils/trackTabSwitch";

const StripeTabs = ({ tabQuery }) => {
  const [tabs] = useState(STRIPE_DASHBOARD_TABS);
  const [toggleState, setToggleState] = useState(tabs[0]);
  const [subscriptionTabKey, setSubscriptionTabKey] = useState(0);
  const getPaymentSetting = useSelector(getPaymentSettings);
  const { isAuthenticateForPayrolls } = usePayrollAuthentication();

  const dispatch = useDispatch();
  const modifiedTabs = useMemo(() => {
    return (getPaymentSetting?.xero_subscription_id !== null &&
      getPaymentSetting?.xero_subscription_status === "ACTIVE") 
      ? tabs?.slice(0, 1)
      : getPaymentSetting?.xero_subscription_id !== null &&
        (getPaymentSetting?.xero_subscription_status === "CANCELLED" ||
          getPaymentSetting?.xero_subscription_status === "PAST_DUE")
      ? tabs
      : (getPaymentSetting?.subscription_status === false &&
          getPaymentSetting?.subscription_id === null &&
          getPaymentSetting?.xero_subscription_id === null &&
          getPaymentSetting?.xero_subscription_status === null) ||
        isAuthenticateForPayrolls?.xero
      ? tabs
      : tabs;
  }, [getPaymentSetting, isAuthenticateForPayrolls, tabs]);
  const toggleTab = (tab) => {
    const fromTab = toggleState?.name ?? toggleState?.id;
    const toTab = tab?.name ?? tab?.id;
    setToggleState(tab);
    if (tab?.id === 3) {
      setSubscriptionTabKey((key) => key + 1);
    }
    try {
      trackTabSwitch("subscription", fromTab, toTab);
    } catch (e) {}
  };

  useEffect(() => {
    dispatch(stripeDefaultPaymentMethod());
  }, []);

  useEffect(() => {
    if (tabQuery && tabQuery === "card") {
      setToggleState(tabs[1]);
    }
  }, [tabQuery]);

  const loadTabComponent = useMemo(() => {
    switch (toggleState.id) {
      case 1:
        return <PaymentMethod />;
      case 2:
        return <StripeInvoices />;
      case 3:
        return <SubscriptionDetails key={subscriptionTabKey} />;
      default:
        return <></>;
    }
  }, [toggleState, subscriptionTabKey]);
  return (
    <div className='bg-white shadow-lg rounded-lg'>
      <div className='print:hidden sticky z-[8] top-[79px]'>
        <div className='bloc-tabs bg-gradient py-4 rounded-t-lg text-white '>
          {modifiedTabs.map((tab, index) => (
            <StripeTabItem
              tabItem={tab}
              key={index}
              toggleTab={toggleTab}
              selectedTab={toggleState.id}
            />
          ))}
        </div>
      </div>
      <div className='content-tabs'>
        <div className={"content active-content"}>{loadTabComponent}</div>
      </div>
    </div>
  );
};

export default StripeTabs;
